import ApiClient from "@/api/clients/ApiClient";
import Locales from "@/utils/locales";
import Uicookie from "@/utils/cookie";

export default class QorusClient extends ApiClient {

  constructor() {
    const userToken: string | null = Uicookie.getCustomerToken();
    const QORUS_PORT = process.env.VUE_APP_QORUS_PORT ? ":" + process.env.VUE_APP_QORUS_PORT : "";
    if (userToken) {
      super({
        baseURL: process.env.VUE_APP_QORUS_HTTP_VERSION + "://" + process.env.VUE_APP_QORUS_HOST + QORUS_PORT + process.env.VUE_APP_QORUS_API_ROUTE,
        headers: {
          "Customer-Authorization": userToken,
          Accept: "application/json",
          common: {
            "Authorization": "Bearer " + process.env.VUE_APP_QORUS_API_KEY,
          },
        },
        params: {
          locale: encodeURIComponent(Locales.getLocaleCode()),
        },
      });
    } else {
      super({
        baseURL: process.env.VUE_APP_QORUS_HTTP_VERSION + "://" + process.env.VUE_APP_QORUS_HOST + QORUS_PORT + process.env.VUE_APP_QORUS_API_ROUTE,
        headers: {
          Accept: "application/json",
          common: {
            "Authorization": "Bearer " + process.env.VUE_APP_QORUS_API_KEY,
          },
        },
        params: {
          locale: encodeURIComponent(Locales.getLocaleCode()),
        },
      });
    }
  }

  static of(): QorusClient {
    return new QorusClient();
  }
}
